/* Página atualizada e funcionando

Essa parte de layouts serve para chamar o código que está em pages, onde tudo é realmente montado.

*/

import Noticias from "pages/Empresa/Noticias";

export default function NoticiasPage() {
  return <Noticias />;
}
